import { render, staticRenderFns } from "./lap_restitusi_kompensasi.vue?vue&type=template&id=02fa4c03&"
import script from "./lap_restitusi_kompensasi.vue?vue&type=script&lang=js&"
export * from "./lap_restitusi_kompensasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports